import axios from 'axios';
import { config } from '../config';

export interface SubZone {
  subZoneId: number;
  stockZoneId: number;
  stockZoneLabel: string;
  label: string;
  name: string;
  isEnabled: boolean;
  isDefault: boolean;
  addressCount: number;
}

// Hand-written until the swagger client is regenerated for the SubZones controller.
export const getSubZones = (stockZoneId?: number) =>
  axios.get(`${config.api.url}/api/v1/SubZones.query`, {
    params: { stockZoneId, onlyEnabled: true },
  });
